import React,{Component} from 'react';
import { Modal } from 'react-bootstrap';
import {Button,FormInput,  FormGroup,} from "shards-react";


export default class ViewExam extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
                    subjects:[],
                  };

    this.setPassingMarks = this.setPassingMarks.bind(this);
    this.setTotalMarks   = this.setTotalMarks.bind(this);

  }



  setPassingMarks = (marks,name) =>{
      console.log(name,marks);
      var sub_data = this.state.subjects;

      for(var i=0;i<sub_data.length;i++){
        if(sub_data[i].subjectname===name){
            sub_data[i].passing = marks;
        }
      }
      this.setState({subjects:sub_data});
      console.log(this.state);
  }

  setTotalMarks = (marks,name) =>{
      console.log(name,marks);
      var sub_data = this.state.subjects;

      for(var i=0;i<sub_data.length;i++){
        if(sub_data[i].subjectname===name){
            sub_data[i].total = marks;
        }
      }

      this.setState({subjects:sub_data});
      console.log(this.state);
  }


  render(){
    if(this.props.subjects.length!==0 && this.state.subjects.length===0){
      this.setState({subjects:this.props.subjects})
    } 
  return (
    <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Exam</Modal.Title>
        </Modal.Header>
        <Modal.Body>

            <table className="table mb-0">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    #
                  </th>
                  <th scope="col" className="border-0">
                    Subject Name
                  </th>
                  
                  <th scope="col" className="border-0">
                     Passing Marks
                  </th>
                  <th scope="col" className="border-0">
                      Maximum Marks
                  </th>
                  
                </tr>
              </thead>
             <tbody>
                     {
                    this.props.subjects.map((item,i)=>{
                      return <TRow  data={item} 
                                    key={i} 
                                    index={i+1}
                                    setPassingMarks={this.setPassingMarks}
                                    setTotalMarks ={this.setTotalMarks}
                                    />
                    })
                  }
              </tbody>
            </table>

        </Modal.Body>
        <Modal.Footer>
          <Button   theme="danger" onClick={this.props.handleClose}>
              Cancel
          </Button>

          <Button theme="info" onClick={()=>{this.props.updatedata({exam_name:this.props.examname,subjects:this.state.subjects})}}>
              Update
          </Button>
         
        </Modal.Footer>
      </Modal>
    );
  }
}



class TRow extends Component{
  render(){
    return(
      <tr>
        <td>{this.props.index}</td>
        <td>{this.props.data.subjectname}</td>
        <td>{ 
            <FormGroup>
              <FormInput id="feInputExamName" 
                        onChange={(evt)=>{this.props.setPassingMarks(evt.target.value,this.props.data.subjectname)}} 
                        placeholder={this.props.data.passing}
                />
            </FormGroup>
        }</td>
        <td><FormGroup> 
              <FormInput id="feInputExamName"  
                        onChange={(evt)=>{this.props.setTotalMarks(evt.target.value,this.props.data.subjectname)}} 
                        placeholder={this.props.data.total}
                />
            </FormGroup></td>  
      </tr>

    )
  }
}